<template>
    <div class="text-[#2b2b2b]">
        <div class="mb-4 flex items-center justify-between">
            <h2 class="text-4xl">Mes Objectifs</h2>
            <button v-on:click="pushToCreate()" class="text-white bg-[#3c41e9] rounded-lg w-[180px] py-3 flex items-center justify-center">
                Ajouter un objectif
            </button>
        </div>

        <div class="bg-white rounded-lg p-4 mb-3">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-x-2 text-black font-light rounded-md">
                    <span v-bind:class="getActiveClass('Liste Objectif')" v-on:click="selectBar('Liste Objectif')">Liste Objectif</span>
                    <span v-bind:class="getActiveClass('Equipe')" v-on:click="selectBar('Equipe')">Equipe</span>
                    <span v-bind:class="getActiveClass('Review')" v-on:click="selectBar('Review')">Review</span>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <div v-if="getActiveTab('Liste Objectif')" class="p-4 text-[#2b2b2b] bg-white rounded-lg mt-3">
                <h2 class="text-[16px] font-light underline">Liste des objectifs</h2>
                <div v-if="this.objectifs.length == 0" class="alert bg-black mt-3">
                    <center>Pas de données trouvées</center>
                </div>
                <div v-else class="body mt-2">
                    <div class="table-responsive" v-if="!isLoading">
                        <table class="table table-bordered table-striped table-hover tableEmployee">
                            <thead>
                                <tr>
                                    <th>Titre</th>
                                    <th>Résultat clé</th>
                                    <th>Actions clés</th>
                                    <th>Type d'objectif</th>
                                    <th>Début</th>
                                    <th>Fin</th>
                                    <th>Update</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="objectif in objectifs" :key="objectif.id">
                                    <td>
                                        <div class="form-line">
                                            <input v-model="objectif.title" type="text" id="title" class="form-control" placeholder="Entrer le titre">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-line">
                                            <textarea v-model="objectif.key_results" name="" id="description" class="form-control" placeholder="Entrer la description"></textarea>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <textarea v-model="objectif.key_actions" name="" id="description" class="form-control" placeholder="Entrer la description"></textarea>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <select v-model="objectif.type" name="obtype" id="obtype" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                            <option value="">Choisissez le type</option>
                                            <option value="PERSONNEL">PERSONNEL</option>
                                            <option value="COLLECTIF">COLLECTIF</option>
                                            <option value="COLLABORATIF">COLLABORATIF</option>
                                        </select>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <input v-model="objectif.start" type="date" name="start" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <input v-model="objectif.end" type="date" name="end" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                        </div>
                                    </td>

                                    <td>
                                        <div class="form-line">
                                            <button v-on:click="pushDetails(objectif.id,getLastValue(objectif.updates))" class="text-white bg-[#3c41e9] px-4 py-2 rounded-md">Update</button>
                                        </div>
                                    </td>

                                    <td>
                                        <button
                                            v-on:click="updateObjectif(objectif.id,objectif.title,objectif.key_results,objectif.key_actions,objectif.type,objectif.start,objectif.end)"
                                            type="button" class="btn bg-blue btn-circle waves-effect waves-circle waves-float">
                                                <i class="material-icons">send</i>
                                        </button>
                                                -
                                        <button v-on:click="removeObejectif(objectif.id)" type="button"
                                            class="btn bg-red btn-circle waves-effect waves-circle waves-float">
                                                <i class="material-icons">delete</i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style="display: flex; justify-content:center" v-else>
                        <div class="preloader pl-size-xs">
                            <div class="spinner-layer pl-indigo">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="getActiveTab('Equipe')" class="p-4 text-[#2b2b2b] bg-white rounded-lg mt-3 flex items-start gap-x-4">
                <teamGoalViewVue />
            </div>

            <div v-if="getActiveTab('Review')" class="p-4 text-[#2b2b2b] bg-white rounded-lg mt-3 flex items-start gap-x-4">
                <reviewViewVue />
            </div>
        </div>
    </div>
</template>
<script>
import API from '@/service/API';
import toast from '@/components/ui/toast';
import router from "@/router/index.js";
import teamGoalViewVue from './team-goal-view.vue';
import reviewViewVue from './review-view.vue';
export default {
    name : "TaskView",
    components:{teamGoalViewVue,reviewViewVue},
    props:[],
    data(){
        return {
            isLoading:true,
            asSend:false,
            active:"Liste Objectif",
            objectifs:[],
        }
    },
    mounted(){
        this.getAllObjectif();
    },
    methods:{
        getActiveClass(libelle){
            return `px-4 py-3 rounded-md cursor-pointer ${libelle == this.active ? "bg-[#5357eb] text-white" : "bg-[#f9fafb] text-black"}`;
        },
        selectBar(libelle){
            this.active = libelle;
        },
        getActiveTab(libelle){
            return this.active == libelle
        },
        getAllObjectif(){
            this.isLoading = true;
            API.get("/goalsByUser/"+localStorage.getItem("userId"))
            .then((data)=>{
                this.objectifs = data.data.data;
            })
            .catch(e=>{console.log(e)})
            .finally(()=>{this.isLoading = false})
        },
        updateObjectif(id,title,key_results,key_actions,type,start,end){
            const userID = localStorage.getItem("userId")
            API.put("/goals/"+id,{
                title,key_results,key_actions,type,start,end,user_id: userID
            })
            .then(()=>{
                toast.success("Succès","Objectif modifié",3000);
                this.getAllObjectif();
            })
            .catch()
        },
        removeObejectif(id){
            API.delete("/goals/"+id)
            .then(()=>{
                toast.success("Succès","Objectif supprimé",3000);
                this.getAllObjectif()
            })
            .catch()
        },
        pushDetails(id,percent = 0){
            router.push({path:"task/"+id+"/"+percent});
        },
        pushToCreate(){
            router.push({path:"task/create"});
        },
        getLastValue(tab){
            const length = tab.length;
            if(length == 0) return 0;
            return tab[length - 1].percentage;
        }
    }
}
</script>